import React, { useState } from "react";
import {
  Box,
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  Typography,
} from "@mui/material";
import { Close } from "@mui/icons-material";

const DeleteUserModel = ({ setOpen, open, handleDelete }) => {
  const [isLoading, setIsLoading] = useState(false);

  const handleClose = () => {
    setOpen({ open: false, data: null });
  };

  const handleCancelSubscription = async () => {
    try {
      setIsLoading(true);
      await handleDelete(open.data);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Dialog open={open.open} onClose={handleClose} maxWidth="xs" fullWidth>
      <DialogTitle>Delete User?</DialogTitle>
      <Box position="absolute" top={0} right={0}>
        <IconButton onClick={handleClose}>
          <Close />
        </IconButton>
      </Box>
      <DialogContent sx={{ py: 1 }}>
        <Typography variant="subtitle1" gutterBottom>
          All subscriptions will be cancelled and the user access will be
          revoked. Are you sure you want to proceed?
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose} color="primary" variant="outlined" className="glass-button-secondary-50">
          Close
        </Button>
        <Button
          onClick={handleCancelSubscription}
          color="primary"
          variant="contained"
          disabled={isLoading}
        >
          {isLoading ? (
            <CircularProgress color="inherit" size={25} />
          ) : (
            "Yes, Delete"
          )}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DeleteUserModel;
